<template>
  <ul class="DocumentsComponent">
    <li
      v-for="(item, i) in items"
      :key="i"
      class="row"
    >
      <div>
        <button @click="downloadDocument(item)">
          <i class="icon-file-04"></i>
          {{ item.title }}
        </button>
        <p v-if="item.text">{{ item.text }}</p>
      </div>
    </li>
  </ul>
</template>

<script setup lang="ts">
import ConsoleError from '@/modules/core/models/errors/ConsoleError';
import { useCommonStore } from '@/modules/core/stores/commonStore'

import { base64ToBlob } from '@/utils/converterUtils'

const commonStore = useCommonStore()
interface PropsInterface {
  items: { title: string; id: string; text: string, documentType?:string, damImage?:string, mimeType?:string }[]
  productCode: string
  businessLine: string
}
withDefaults(defineProps<PropsInterface>(), {})

function downloadDocument(item: any) {
  if (item.documentType === 'dam' && !!item.damImage && !!item.mimeType) {
    openDocumentAem(item)
    return
  } else if(item.documentType === 'alfresco') {
    commonStore.downloadDocumentByReference(item.id, item.title)
    return
  } else {
    return new ConsoleError({ message: 'documentType, damImage or mimeType incorrect' })
  }
}

function openDocumentAem(item: any) {
  const blob = base64ToBlob(item.damImage, item.mimeType)
  const url = URL.createObjectURL(blob)
  window.open(url, '_blank')
}
</script>

<style lang="scss" scoped>
.DocumentsComponent {
  all: unset;

  .row {
    padding: $spacing-m;
    border-bottom: solid 1px $color-neutral-light;

    button {
      color: $color-primary;
      font-size: $font-size-l;
      font-weight: $font-weight-700;
      display: flex;
      gap: $gap-5;
      align-items: center;
    }
  }
}
</style>
